import React from 'react';
import type { EvaluationJobLiveProgress } from '../../types/evaluationJob';
import '../training/FineTuningJobProgress.css';

export interface EvaluationJobProgressBarProps {
  percent: number;
  message?: string | null;
  meta?: string | null;
  title?: string;
  accentColor?: string;
  className?: string;
}

const EvaluationJobProgressBar: React.FC<EvaluationJobProgressBarProps> = ({
  percent,
  message,
  meta,
  title = 'Evaluation progress',
  accentColor = '#0099FA',
  className = '',
}) => {
  const clamped = Math.max(0, Math.min(100, percent));
  const widthPercent = clamped > 0 ? Math.max(clamped, 2) : 0;

  return (
    <div className={['ft-job-progress', className].filter(Boolean).join(' ')}>
      <div className="ft-job-progress__head">
        <span className="ft-job-progress__title">{title}</span>
        <span className="ft-job-progress__percent">{Math.round(clamped)}%</span>
      </div>
      <div
        className="ft-job-progress__track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(clamped)}
        aria-label={`${title} ${Math.round(clamped)} percent`}
      >
        <div
          className="ft-job-progress__fill ft-job-progress__fill--running"
          style={{ width: `${widthPercent}%`, background: accentColor }}
        />
      </div>
      {message ? <div className="ft-job-progress__label">{message}</div> : null}
      {meta ? (
        <div className="ft-job-progress__label" style={{ opacity: 0.85, marginTop: message ? 4 : undefined }}>
          {meta}
        </div>
      ) : null}
    </div>
  );
};

export default EvaluationJobProgressBar;
